/* fs-video-reels — grid autoplay + Vizup-style popup (mute/pause/share/ATC/peek). */
(function () {
  var section = document.querySelector('.fs-video-reels');
  if (!section) return;

  var cards = [].slice.call(section.querySelectorAll('[data-fs-reel-card]'));
  var dialog = section.querySelector('[data-fs-reel-dialog]');
  var player = null; // set to the active slide's <video> by open()
  var current = 0, currentVariant = null;

  /* Grid: muted autoplay in view, looping a short preview rather than the whole
     reel — Vizup ships a separate ~3s "snip" file per video; we clip in the player
     instead of hosting a second copy of every asset. */
  var PREVIEW_SECS = 3.3;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target.querySelector('video'); if (!v) return;
      if (e.isIntersecting) {
        // nothing is fetched until the section is actually scrolled to
        if (v.dataset.src) { v.src = v.dataset.src; delete v.dataset.src; }
        v.muted = true; v.play().catch(function () {});
      } else { v.pause(); }
    });
  }, { threshold: 0.4, rootMargin: '200px' });
  cards.forEach(function (c) {
    io.observe(c);
    var v = c.querySelector('video');
    if (v) v.addEventListener('timeupdate', function () {
      if (v.currentTime >= PREVIEW_SECS) v.currentTime = 0;
    });
  });

  /* Carousel arrows. */
  var track = section.querySelector('[data-fs-reels]');
  var step = function () { var c = track && track.querySelector('.fs-video-reels__card'); return c ? c.offsetWidth + 16 : 260; };
  var pa = section.querySelector('[data-fs-track-prev]'), na = section.querySelector('[data-fs-track-next]');
  function upd() { if (!track) return; var m = track.scrollWidth - track.clientWidth - 2; if (pa) pa.disabled = track.scrollLeft <= 2; if (na) na.disabled = track.scrollLeft >= m; }
  if (pa) pa.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (na) na.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  /* Mobile shows dots instead of arrows (like fs-bestsellers). One dot per card;
     the active one follows the scroll position. */
  var dots = section.querySelector('[data-fs-reel-dots]');
  function buildDots() {
    if (!dots || !track || dots.children.length) return;
    cards.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fs-video-reels__dot';
      b.setAttribute('aria-label', 'Go to video ' + (i + 1));
      b.addEventListener('click', function () {
        track.scrollTo({ left: c.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });
    dots.hidden = false;
  }
  function syncDots() {
    if (!dots || !dots.children.length || !track) return;
    // nearest card to the track's left edge wins
    var best = 0, min = Infinity;
    cards.forEach(function (c, i) {
      var d = Math.abs((c.offsetLeft - track.offsetLeft) - track.scrollLeft);
      if (d < min) { min = d; best = i; }
    });
    [].forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === best); });
  }
  function updAll() { upd(); syncDots(); }
  if (track) {
    buildDots();
    track.addEventListener('scroll', updAll, { passive: true });
    window.addEventListener('resize', updAll, { passive: true });
    updAll();
  }

  if (!dialog) return;

  function data(card) {
    var chip = card.querySelector('.fs-video-reels__product');
    return {
      title: chip && chip.getAttribute('data-title'),
      url: chip && chip.getAttribute('data-url'),
      price: chip && chip.getAttribute('data-price'),
      compare: chip && chip.getAttribute('data-compare'),
      img: chip && chip.getAttribute('data-img'),
      variant: chip && chip.getAttribute('data-variant')
    };
  }

  function pct(price, compare) {
    var p = parseFloat((price || '').replace(/[^\d.]/g, '')), c = parseFloat((compare || '').replace(/[^\d.]/g, ''));
    if (!c || c <= p) return null;
    return Math.round((c - p) * 100 / c) + '% OFF';
  }

  var muteBtn = dialog.querySelector('[data-fs-reel-mute]');
  var playBtn = dialog.querySelector('[data-fs-reel-play]');
  var off = dialog.querySelector('[data-fs-reel-doff]');
  var atc = dialog.querySelector('[data-fs-reel-atc]');
  var prod = dialog.querySelector('[data-fs-reel-dprod]');

  /* `el.hidden = x` is an HTMLElement property — on an <svg> it does nothing, which
     is why toggling it left both icons stuck. Drive a class instead. */
  function showIcon(el, on) {
    if (!el) return;
    // markup ships [hidden] as the initial state; from here .is-hidden owns it
    if (el.hasAttribute('hidden')) el.removeAttribute('hidden');
    el.classList.toggle('is-hidden', !on);
  }
  function syncMute() {
    if (!muteBtn || !player) return;
    showIcon(muteBtn.querySelector('[data-ico-on]'), !player.muted);
    showIcon(muteBtn.querySelector('[data-ico-off]'), player.muted);
  }
  function syncPlay() {
    if (!playBtn || !player) return;
    showIcon(playBtn.querySelector('[data-ico-pause]'), !player.paused);
    showIcon(playBtn.querySelector('[data-ico-play]'), player.paused);
  }

  /* The playing video IS the active slide's <video> — `player` points at it, so
     the existing timeline / mute / pause controls keep working unchanged.
     fromSwiper=true means Swiper already moved; don't ask it to move again. */
  /* Loop mode clones slides, and swiper.activeIndex drifts from what's actually
     marked active in the DOM after a re-open — binding off it played the wrong
     reel. The .swiper-slide-active element is the one on screen; trust that. */
  function slideVideo(i) {
    if (!row) return null;
    var v = row.querySelector('.swiper-slide-active video');
    if (v) return v;
    var slides = row.querySelectorAll('[data-fs-reel-slide]');
    return slides[i] ? slides[i].querySelector('video') : null;
  }
  function open(i, fromSwiper) {
    var n = cards.length;
    current = ((i % n) + n) % n;

    // Only one reel plays at a time. Clones mean "the last player" isn't enough —
    // stop every video in the row before handing over.
    if (row) row.querySelectorAll('video').forEach(function (x) { x.pause(); x.muted = true; });

    var d = data(cards[current]);
    currentVariant = d.variant || null;
    if (d.title) {
      prod.hidden = false; prod.href = d.url;
      dialog.querySelector('[data-fs-reel-dtitle]').textContent = d.title;
      dialog.querySelector('[data-fs-reel-dprice]').innerHTML = d.price + (d.compare ? ' <s>' + d.compare + '</s>' : '');
      var o = pct(d.price, d.compare);
      off.hidden = !o; off.textContent = o || '';
      var im = dialog.querySelector('[data-fs-reel-dimg]'); im.src = d.img || ''; im.alt = d.title;
      if (atc) { atc.disabled = !d.variant; atc.textContent = 'Add To Cart'; }
    } else { prod.hidden = true; }

    var bar0 = dialog.querySelector('[data-fs-reel-bar]'); if (bar0) bar0.style.width = '0%';
    var sh0 = dialog.querySelector('[data-fs-reel-sheet]'); if (sh0) sh0.hidden = true;
    if (!dialog.open) {
      dialog.showModal();
      syncCart(); // cart may have changed while the popup was closed
      initSwiper(current);
      // Swiper exists from a previous open — jump it (no animation, nothing visible
      // yet) so the reel we were asked for is the one on screen.
      if (swiper && swiper.realIndex !== current) {
        swiper.params.loop ? swiper.slideToLoop(current, 0, false) : swiper.slideTo(current, 0, false);
      }
    }
    // Only reposition when the caller (a grid card) opened us at an index. If Swiper
    // moved itself, re-issuing slideToLoop here fights its own loop reset and the
    // row visibly races across several slides before settling.
    // Swiper applies .swiper-slide-active asynchronously, so bind on the next frame
    // once the class has landed — otherwise we grab the previous slide's video.
    requestAnimationFrame(function () {
      var v = slideVideo(current);
      if (v) { player = v; player.muted = false; player.currentTime = 0; }
      if (player) player.play().then(syncPlay).catch(syncPlay);
      syncMute();
    });
  }
  // Don't clear src — the player is now a slide's own <video>, not a scratch element.
  function close() { if (player) player.pause(); var sh = dialog.querySelector('[data-fs-reel-sheet]'); if (sh) sh.hidden = true; if (dialog.open) dialog.close(); }

  /* Swiper owns the slide motion — same library the theme already loads for
     fs-bestsellers. slideTo() just asks it to move; open() re-runs off its
     slideChange so the chrome always matches the active slide. */
  var row = dialog.querySelector('[data-fs-reel-row]');
  var swiper = null;
  // Popup videos ship with data-src so a closed dialog costs zero requests.
  function hydrateSlides() {
    if (!row) return;
    row.querySelectorAll('video[data-src]').forEach(function (v) {
      v.src = v.getAttribute('data-src');
      v.removeAttribute('data-src');
      v.preload = 'metadata'; // paints the first frame for the peeking slides
    });
  }
  function initSwiper(startAt) {
    if (swiper || !row || typeof window.Swiper !== 'function') return;
    hydrateSlides();
    swiper = new window.Swiper(row, {
      initialSlide: startAt || 0,
      slidesPerView: 'auto',
      centeredSlides: true,
      // Loop so the first and last reel still get a peek on both sides — that's what
      // the Vizup player does (its peeks are static thumbnails, so its clone reset
      // never reads as motion).
      loop: cards.length > 2,
      loopPreventsSliding: true,
      // Desktop slides are 340 boxes that paint at ~208 when scaled down, so the
      // negative gap pulls that dead space back in. Mobile slides are full-bleed
      // with no scaling, so they need a real gap instead.
      spaceBetween: 0,
      breakpoints: { 861: { spaceBetween: -48 } },
      speed: 380,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      on: {
        slideChange: function (s) {
          var i = s.realIndex != null ? s.realIndex : s.activeIndex;
          if (i !== current) open(i, true);
        }
      }
    });
  }
  function slideTo(i) {
    if (!swiper) { open(i); return; }
    var n = cards.length, t = ((i % n) + n) % n;
    swiper.params.loop ? swiper.slideToLoop(t) : swiper.slideTo(t);
  }

  cards.forEach(function (card, i) {
    // both the video surface and the bag badge open the reel
    card.querySelectorAll('[data-fs-reel-open]').forEach(function (b) {
      b.addEventListener('click', function () { open(i); });
    });
  });
  dialog.querySelectorAll('[data-fs-reel-close]').forEach(function (b) { b.addEventListener('click', close); });
  dialog.querySelector('[data-fs-reel-prev]').addEventListener('click', function () { slideTo(current - 1); });
  dialog.querySelector('[data-fs-reel-next]').addEventListener('click', function () { slideTo(current + 1); });
  if (muteBtn) muteBtn.addEventListener('click', function () { if (!player) return; player.muted = !player.muted; syncMute(); });
  if (playBtn) playBtn.addEventListener('click', function () { if (!player) return; player.paused ? player.play() : player.pause(); syncPlay(); });

  /* Progress/timeline bar. Delegated in capture phase: media events don't bubble,
     and `player` changes with every slide. */
  var bar = dialog.querySelector('[data-fs-reel-bar]');
  if (row) {
    row.addEventListener('timeupdate', function (e) {
      if (e.target !== player || !bar || !player.duration) return;
      bar.style.width = (player.currentTime / player.duration * 100) + '%';
    }, true);
    row.addEventListener('play', function (e) { if (e.target === player) syncPlay(); }, true);
    row.addEventListener('pause', function (e) { if (e.target === player) syncPlay(); }, true);
  }

  /* Share bottom-sheet. */
  var sheet = dialog.querySelector('[data-fs-reel-sheet]');
  var share = dialog.querySelector('[data-fs-reel-share]');
  function shareUrl() { var u = data(cards[current]).url; return u ? location.origin + u : location.href; }
  function shareTitle() { return data(cards[current]).title || document.title; }
  function buildLinks() {
    if (!sheet) return;
    var u = encodeURIComponent(shareUrl()), t = encodeURIComponent(shareTitle());
    var map = {
      whatsapp: 'https://wa.me/?text=' + t + '%20' + u,
      twitter: 'https://twitter.com/intent/tweet?url=' + u + '&text=' + t,
      email: 'mailto:?subject=' + t + '&body=' + u,
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + u,
      pinterest: 'https://pinterest.com/pin/create/button/?url=' + u + '&description=' + t
    };
    sheet.querySelectorAll('[data-share]').forEach(function (a) { a.href = map[a.getAttribute('data-share')] || u; });
  }
  if (share && sheet) share.addEventListener('click', function () { buildLinks(); sheet.hidden = false; });
  var sc = dialog.querySelector('[data-fs-reel-share-close]');
  if (sc) sc.addEventListener('click', function () { sheet.hidden = true; });
  var copy = dialog.querySelector('[data-fs-reel-copy]');
  if (copy) copy.addEventListener('click', function () {
    var lbl = dialog.querySelector('[data-fs-reel-copy-label]');
    (navigator.clipboard ? navigator.clipboard.writeText(shareUrl()) : Promise.reject()).then(function () {
      if (lbl) { lbl.textContent = 'Copied!'; setTimeout(function () { lbl.textContent = 'Copy Link'; }, 1500); }
    }).catch(function () {});
  });

  /* Cart badge — live item count, opens the theme's cart drawer. */
  var cartBtn = dialog.querySelector('[data-fs-reel-cart]');
  var cartCount = dialog.querySelector('[data-fs-reel-cart-count]');
  function syncCart() {
    if (!cartCount) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartCount.textContent = c.item_count; })
      .catch(function () {});
  }
  /* The badge only refreshed on our own add — removing an item elsewhere (drawer,
     cart page) left it stale. Listen on the same channels the theme broadcasts on. */
  document.addEventListener('cart:updated', function () { syncCart(); setTimeout(syncCart, 300); });
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(syncCart, 250); }); } catch (e) {}
  }

  if (cartBtn) cartBtn.addEventListener('click', function (e) {
    // nested inside the product <a> — keep the click off the PDP link
    e.preventDefault(); e.stopPropagation();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { close(); drawer.open(); }
    else window.location.href = '/cart';
  });
  syncCart();

  /* Mirrors fs-bundles' add flow. A bare /cart/add.js updates the cart but leaves the
     header count and drawer stale — the theme only re-renders off the section payload
     plus its own cartUpdate channel, not a custom event. */
  if (atc) atc.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    if (!currentVariant) return;
    var drawer = document.querySelector('cart-drawer');
    atc.disabled = true; atc.textContent = 'Adding…';
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(currentVariant, 10), quantity: 1 }],
        sections: ['cart-drawer'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
      .then(function (json) {
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(json);
        if (typeof window.fsUpdateCartCounts === 'function') window.fsUpdateCartCounts();
        if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'fs-video-reels' });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: json }));
        atc.textContent = 'Added ✓';
        syncCart();
        setTimeout(function () { atc.textContent = 'Add To Cart'; atc.disabled = false; }, 1600);
      })
      .catch(function () { atc.textContent = 'Add To Cart'; atc.disabled = false; });
  });

  dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
  dialog.addEventListener('cancel', function () { if (player) player.pause(); });
})();
